import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In your frontend, you should call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` as soon as you're able to. Typically, this is every time your app loads for the first time, and directly after your users log in. This ensures that events sent during your users' sessions are correctly associated with them. `}</p>
    <p>{`You only need to call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` once per session.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      